import React from "react";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import ReservationDetails from "./ReservationDetails";
import HallRoomDetailsList from "./HallRoomDetailsList";
import PaymentDetails from "./PaymentDetails";

const EditHallBookingForm = ({
  values,
  errors,
  handleChange,
  handleHallChange,
  handleSubmit,
  loading,
  formdata,
  setValues,
  hallRoomTypes,
  paymentMethods,
  halls,
  addHall,
  removeHall,
  billingRates,
  foodPackages = [],
  foodPackageDetails = {},
  pftlData = [],
  allFoods = [],
  isHallSectionEnabled = false,
  isEditMode = false
}) => {

  const optionConfig = {
    hallroom_type_id: {
      list: hallRoomTypes ? Array.from(new Map(hallRoomTypes.map(item => [item.hallroom_type, item])).values()) : [],
      valueKey: "id",
      labelKey: "hallroom_type",
    },
    payment_method_id: {
      list: paymentMethods,
      valueKey: "id",
      labelKey: "method_name",
    },
    event_type: {
      list: [
        { id: "Wedding", name: "Wedding" },
        { id: "Conference", name: "Conference" },
        { id: "Meeting", name: "Meeting" },
        { id: "Party", name: "Party" },
      ],
      valueKey: "id",
      labelKey: "name",
    },
    food_package_id: {
      list: foodPackages,
      valueKey: "package_id",
      labelKey: "package_name",
    }
  };

  return (
    <>
      <PageBody
        onSubmit={handleSubmit}
        headerchildren={<HeadingOne>Update Hall Booking</HeadingOne>}
        card={false}
      >
        <ReservationDetails
          formdata={formdata}
          values={values}
          errors={errors}
          handleChange={handleChange}
          optionConfig={optionConfig}
        />

        <HallRoomDetailsList
          halls={halls}
          handleHallChange={handleHallChange}
          formdata={formdata}
          optionConfig={optionConfig}
          errors={errors}
          addHall={addHall}
          removeHall={removeHall}
          values={values}
          setValues={setValues}
          foodPackages={foodPackages}
          foodPackageDetails={foodPackageDetails}
          pftlData={pftlData}
          allFoods={allFoods}
          hallRoomTypes={hallRoomTypes}
          isHallSectionEnabled={isHallSectionEnabled}
          isEditMode={isEditMode}
        />

        <PaymentDetails
          formdata={formdata}
          values={values}
          errors={errors}
          handleChange={handleChange}
          optionConfig={optionConfig}
          billingRates={billingRates}
        />

        <FormSubmitButton
          label="Update Booking"
          loading={loading}
          colSize="col-12"
          align="end"
          className="mt-4"
        />
      </PageBody>
    </>
  );
};

export default EditHallBookingForm;
